import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFingersClapCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 48,
	viewBox: "0 0 64 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30 47.5C28.6667 43.8333 26.7563 28.6916 27.0254 23.0412C27.5255 12.5411 33.5254 11.041 35.0254 11.041C36.5254 11.041 38.3254 11.8411 37.5254 13.0411C36.7254 14.2411 34.0254 15.5407 32.5254 18.041C31.0254 20.5414 30.8944 22.6203 33.0254 24.041C36.0254 26.041 40.5254 23.0409 41.0254 22.041C41.5254 21.2077 42.5254 18.941 42.5254 16.541C42.5254 13.541 42.5254 12.5414 42.5254 11.0414C42.5254 9.54138 41.0254 10.541 39.5254 10.541C38.0254 10.541 37.5254 10.0411 37.5254 9.54108C37.5254 9.04108 40.5254 5.04109 42.5254 4.54109C44.5254 4.04109 47.135 5.52718 47.5254 9.04109C48.0254 13.5411 46.0254 24.0414 45.5254 24.0414C45.0254 24.0414 49.142 6.07526 49.5254 4.54135C50.0254 2.54138 50.1535 0.698399 51.5254 1.0414C53.5254 1.54141 53.0254 10.5414 52.5254 13.5414C52.1254 15.9414 50.6921 23.208 50.0254 26.5414C50.8588 25.0414 52.1254 19.341 52.5254 16.541C53.0254 13.041 54.0254 7.54141 54.5254 6.04138C55.0254 4.54135 56.4191 3.17758 57.0254 3.54138C59.5254 5.04138 55.8588 20.0414 55.0254 28.0414C55.5254 28.2078 56.0254 26.0414 57.0254 22.041C58.1234 17.6488 59.5254 7.20805 61.5254 8.54138C62.7254 9.34138 59.5 26.6667 58 34.5L54.5254 47.5",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.5 8.5L23 3",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36 6L36.5 2.5",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.5 5L30.5 1.5",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.00621 12.3959L7.68818 16.5549C7.93765 17.1717 8.81826 17.216 9.34891 16.6383L15.447 10",
			stroke: "#6C6DCE",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 1.19043C10.243 1.19043 10.4946 1.27565 10.8643 1.53125C11.055 1.66312 11.2631 1.82965 11.5039 2.03613L12.3418 2.78027L18.3418 8.17969C18.9411 8.71902 19.1869 8.95199 19.3193 9.18164L19.3701 9.28027C19.4898 9.54893 19.5 9.85994 19.5 10.7812V18C19.5 18.9569 19.4993 19.6244 19.4316 20.1279C19.3659 20.6171 19.2451 20.876 19.0605 21.0605C18.876 21.2451 18.6171 21.3659 18.1279 21.4316C17.6244 21.4993 16.9569 21.5 16 21.5H4C3.04308 21.5 2.37563 21.4993 1.87207 21.4316C1.38289 21.3659 1.12396 21.2451 0.939453 21.0605C0.754944 20.876 0.634128 20.6171 0.568359 20.1279C0.500662 19.6244 0.5 18.9569 0.5 18V10.7812C0.500001 9.97554 0.507883 9.63679 0.589844 9.38477L0.629883 9.28027C0.719626 9.07888 0.868149 8.90728 1.22559 8.57422L1.6582 8.17969L7.6582 2.78027C8.30424 2.19884 8.7543 1.795 9.13574 1.53125C9.50542 1.27565 9.75698 1.19043 10 1.19043Z",
			stroke: "black",
			strokeOpacity: .12
		})
	]
});
export default SvgFingersClapCheck;
